import { client, gql } from './Client';

const validateComponentInfo = gql`
  query mobileValidateComponentInfo($parentcomponentIdInput: Int!, $childcomponentIdInput: Int!) {
    mobileValidateComponentInfo(
      parentcomponentId: $parentcomponentIdInput
      childcomponentId: $childcomponentIdInput
    ) {
      display
      value
      sort
    }
  }
`;

const validateComponent = (parentcomponentIdInput: number, childcomponentIdInput: number) => {
  return client.query({
    query: validateComponentInfo,
    variables: { parentcomponentIdInput, childcomponentIdInput },
  });
};

export { validateComponent };
